module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAJBAMAAAAIg/utAAAAG1BMVEUAAAD/aZb6aZH9aY/9aZD8aY/8aY/9aY/8aY9Q1mH/AAAACXRSTlMAETNmd5m7zO7mHy2hAAAAJ0lEQVQI12NQZGBgMBdgYGAtBDLCgQwJBwbGUgYGtgAGBlegEFAEADPVAr8vNcMqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dropdown-hover.png
// module id = 652
// module chunks = 0